export default {
    screenShowSet: {
        method: "POST",
        url: "/adminScreen/screen-user/screen-set",
        name: "展示数据设置"
    },
    screenShowInfo: {
        method: "POST",
        url: "/adminScreen/screen-user/screen-set-info",
        name: "展示数据设置详情"
    },
};